import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UploadService {
  constructor(private http: HttpClient) {}

  postFile(apiUrl: string, files: Array<File>): Observable<any> {
    const formData: FormData = new FormData();
    for (let i = 0; i < files.length; i++) {
      formData.append('file', files[i], files[i].name);
    }

    return of(formData);
    // return this.http.post(`${BASE_URL}/${ apiUrl }`, formData, {}).map((res: any) => res.result.data);
    // .catch((e) => this.handleError(e));
  }

  // pushFileToStorage(file: any): Observable<HttpEvent<{}>> {
  //   const formdata: FormData = new FormData();
  //   const listFile: any = [];
  //   for (let i = 0; i < file.length; i++) {
  //     // console.log('file: ', file);
  //     formdata.append('files', file[i]);
  //   }
  //   var options = { content: formdata };
  //   const req = new HttpRequest('POST', `${BASE_URL}/media/uploads`, options, {
  //     reportProgress: true,
  //     responseType: 'text'
  //   });

  //   return this.http.request(req);
  // }

  // getFiles(): Observable<any> {
  //   return this.http.get(`${uploadApi}/all`);
  // }
}
